import SunCalc from "suncalc"

// default amsterdam lat long
export function useSunCalc(date: Date, latitude = 51.5, longitude = -0.1) {
	const { sunrise, sunset } = SunCalc.getTimes(date, latitude, longitude)
	return { sunrise, sunset }
}
